<div [class]="badgeAppliedClasses()" class="px-2 py-0.5 rounded text-sm">
  <p [class]="textAppliedClasses()" [innerHTML]="text()"></p>
</div>
